import React from 'react';
import { ShimmerCircularImage, ShimmerTitle } from "react-shimmer-effects";
import { BaseCard } from '../commonComponents';

const InvoiceLoader = () => {
  return (
    <>
      {
        Array.from({ length: 10 }).map(_ => {
          return (
            <BaseCard customBaseCardStyle='mg-t-15 rounded-3'>
              <div className='d-flex align-items-center'>
                <div className="d-flex align-items-center flex-1">
                  <div className='shimmer-circular-img'><ShimmerCircularImage size={30} className="flex-1 mg-b-0" /></div>
                  <div className='mg-l-10'>
                    <div style={{ width: '100px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
                    <div style={{ width: '75px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block mg-t-5" /></div>
                  </div>
                </div>
                <div className='d-flex flex-column align-items-end'>
                  <div style={{ width: '60px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
                  <div style={{ width: '100px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block mg-t-5" /></div>
                </div>
              </div>
            </BaseCard>
          );
        })
      }
    </>
  );
};

export default InvoiceLoader;
